module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA9ElEQVR4AWOgC7CL20kkIlfD/5vEIijYyMMDQlw8mzh5dnBxNnHy5xtZPFi46FhQ0Dom5o3sXBtY2TZycwPVIDRs42DbosSxyZgjQozbzCHZ0Svr6LnT958+PTOxc4MR385gz51Skhs5OaEaNvFxNjvYL/eUL1Zk4JGSioqONjUxi46OXr5ixZNPH880JK/x0ahz81gvDLNhMxdHmbb3HFHlrewcUQICCmpq0srKOw8evPvkyZmens0cnIt4xXKMItcjO2krJ/tmbq5NPDw7ubnrWFicWFimREWdi4lZz8y8gYt7Ezf3Nk42oDJSQ4keETcoAQB+DMUxPeB8uQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/SZ.png
// module id = 1273
// module chunks = 0